import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import type { LinksColumnValue } from "app/pages/sales-intelligence/modules/lists/types/columns";
import { constructHref } from "app/pages/sales-intelligence/utils/url";

import leadsSearchTrackingService from "../../../services/tracking/trackingService";

import { StyledIconButton } from "./styles";

type Props = {
    value: LeadsSearchRow["links"];
    record: LeadsSearchRow;
};

export const LinksCell: React.FC<Props> = ({ value, record }) => {
    if (!value) {
        return null;
    }

    const onClick = (columnValue: LinksColumnValue) => {
        return () => {
            leadsSearchTrackingService.trackLinksClick(columnValue.type, record.company ?? "", columnValue.url);
        };
    };

    return (
        <Flex
            alignItems="center"
            justifyContent="flex-start"
            gap="8px"
            width="87px"
            margin="0 auto"
        >
            {value.map(({ type, url }) => (
                <Tooltip
                    content={translate(
                        type === "website"
                            ? "grow.lead_generator.exist.table.column.links.website.tooltip"
                            : "grow.lead_generator.exist.table.column.links.linkedin.tooltip",
                    )}
                >
                    <a
                        href={constructHref(url)}
                        target="_blank"
                        data-automation={`contacts-name-cell.link.${type}`}
                        onMouseDown={onClick({ type, url })}
                    >
                        <StyledIconButton
                            iconName={type === "website" ? "link-out" : "social-linkedin"}
                            iconSize="xs"
                            iconColor={colorsPalettes.carbon[300]}
                            type="flat"
                        />
                    </a>
                </Tooltip>
            ))}
        </Flex>
    );
};
